__turbopack_context__.v({
  "Separator": "ExperiencesList-module-scss-module__rJQBUa__Separator",
  "connectButton": "ExperiencesList-module-scss-module__rJQBUa__connectButton",
  "details": "ExperiencesList-module-scss-module__rJQBUa__details",
  "editBtn": "ExperiencesList-module-scss-module__rJQBUa__editBtn",
  "emptyData": "ExperiencesList-module-scss-module__rJQBUa__emptyData",
  "expIcon": "ExperiencesList-module-scss-module__rJQBUa__expIcon",
  "expItem": "ExperiencesList-module-scss-module__rJQBUa__expItem",
  "label": "ExperiencesList-module-scss-module__rJQBUa__label",
  "list": "ExperiencesList-module-scss-module__rJQBUa__list",
  "primaryLabel": "ExperiencesList-module-scss-module__rJQBUa__primaryLabel",
  "root": "ExperiencesList-module-scss-module__rJQBUa__root",
  "row": "ExperiencesList-module-scss-module__rJQBUa__row",
  "secondaryLabel": "ExperiencesList-module-scss-module__rJQBUa__secondaryLabel",
});
